module.exports = __webpack_public_path__ + "img/language_icons.57d8965d.png";